const D = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS40MTQgMTBIMTFjNy44NjkgMCAxMSAzLjI1NiAxMSAxMWgtMmMwLTYuNjU2LTIuMjU0LTktOS05SDUuNDE0bDQuMjkzIDQuMjkzLTEuNDE0IDEuNDE0TDEuNTg2IDExbDYuNzA3LTYuNzA3IDEuNDE0IDEuNDE0TDUuNDE0IDEweiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  D as default
};
//# sourceMappingURL=back_arrow-1ca3fcba.mjs.map
